import React from 'react';
import { faEllipsisVertical, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@frontend/shadcn/components/ui/popover';

const DeleteNodeButton = ({ handleDelete, showOptionsPopover, setShowOptionsPopover, handleOptionsClick, isEditing = true }: { handleDelete: (e: React.MouseEvent) => void, showOptionsPopover: boolean, setShowOptionsPopover: (open: boolean) => void, handleOptionsClick: (e: React.MouseEvent) => void, isEditing?: boolean }) => {
  // Don't render if not in editing mode
  if (!isEditing) {
    return null;
  }

  return (
    <Popover open={showOptionsPopover} onOpenChange={setShowOptionsPopover}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex flex-col w-6 h-6 items-center justify-center gap-2 px-2 py-0.5 bg-white rounded-lg"
          onClick={handleOptionsClick}
        >
          <FontAwesomeIcon icon={faEllipsisVertical} className="w-3 h-3 text-grey-5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-1 rounded-xl" align="start" side="right" sideOffset={10}>
        <Button
          variant="ghost"
          size="xs"
          className="w-full justify-start gap-2 text-red-5 hover:text-red-6 hover:bg-red-1 rounded-md"
          onClick={handleDelete}
        >
          <FontAwesomeIcon icon={faTrash} className="w-3 h-3" />
          Delete Node
        </Button>
      </PopoverContent>
    </Popover>
  );
};

export default DeleteNodeButton;
